import seemerRaysAvatarSrc from "@/assets/images/anim-seemer-rays.png"
import productImgSrc from "@/assets/images/anim-seemer-rays-prod-2.png"
import userAvatarSrc from "@/assets/images/avatar-johnny.png"

import { IHaawAnimation } from "./AnimationPlayer"

export const animationData: IHaawAnimation = {
  agents: [
    { key: "businessPolicies", name: "Business Policies" },
    { key: "crm", name: "CRM" },
    { key: "ecommercePlatform", name: "Ecommerce Platform" },
    { key: "helpdesk", name: "Helpdesk" },
    { key: "inventoryManagement", name: "Inventory Management" },
    { key: "marketingAutomation", name: "Marketing Automation" },
    { key: "orderManagement", name: "Order Management" },
    { key: "productCatalog", name: "Product Catalog" },
  ],
  chat: {
    agentName: "Seemer Rays",
    avatar: seemerRaysAvatarSrc,
    status: "Active",
    user: userAvatarSrc,
  },
  messages: [
    {
      message:
        "Hi, I placed an order that has an incorrect shipping address. My order number is 155-8147. How can I provide the correct address?",
      sender: "user",
    },
    {
      message:
        "Hi Andrew, I'm your personal Seemer Rays AI agent! I'm here to help you update your shipping information for order number 155-8147.",
      sender: "agent",
      thoughtProcesses: ["orderManagement", "crm"],
    },
    {
      message: "Can you please respond with the correct mailing address?",
      sender: "agent",
      thoughtProcesses: [],
    },
    {
      message: "The correct address is: 1234 Red Robin Lane, Anaheim, CA 92807",
      sender: "user",
    },
    {
      message:
        "Great, thanks! Your order has been updated and is scheduled to arrive next Tuesday. You can track your order status using this link: tracking.seemer.co/155-8147",
      sender: "agent",
      thoughtProcesses: ["orderManagement"],
    },
    {
      message: "Please let me know if I can help with anything else!",
      sender: "agent",
      thoughtProcesses: [],
    },
    {
      message:
        "Actually, yes - Do you have the latest Lyon Polarized Sunglasses?",
      sender: "user",
    },
    {
      embed: {
        description: "2 colors",
        image: productImgSrc,
        price: "$199.90",
        title: "Lyon Polarized",
      },
      sender: "agent",
      thoughtProcesses: ["productCatalog", "inventoryManagement"],
    },
    {
      message:
        "Awesome! I found them cheaper on another site - can you offer me a discount?",
      sender: "user",
    },
    {
      message:
        "I can offer you free shipping + a 5% discount if you purchase the glasses in the next hour.",
      sender: "agent",
      thoughtProcesses: ["businessPolicies", "ecommercePlatform"],
    },
    {
      message: "Thank you! Adding them to my cart now!",
      sender: "user",
    },
    {
      message:
        "You’re welcome! I'm available 24/7/365 in case you have additional questions!",
      sender: "agent",
      thoughtProcesses: [],
    },
  ],
}
